import { render, staticRenderFns } from "./salaryApplication.vue?vue&type=template&id=326860b1&scoped=true&"
import script from "./salaryApplication.vue?vue&type=script&lang=js&"
export * from "./salaryApplication.vue?vue&type=script&lang=js&"
import style0 from "./salaryApplication.vue?vue&type=style&index=0&id=326860b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326860b1",
  null
  
)

export default component.exports